<template>
  <v-row>
    <v-col>
      <v-card v-if="surgeryIndication.surgeryType">
        <v-container fluid>
          <v-row>
            <v-col :style="{ whiteSpace: 'pre-line' }">
              <v-row>
                <v-col>
                  <v-row>
                    <v-col v-if="surgeryIndication.surgeryType">
                      <v-row dense>
                        <v-col class="font-weight-bold"> Cirurgia </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.surgeryType.name }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col>
                      <v-row dense>
                        <v-col class="font-weight-bold"> Criada em </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.createdAt | moment("DD/MM/Y") }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col v-if="surgeryIndication.surgeryTypeTechnique">
                      <v-row dense>
                        <v-col class="font-weight-bold"> Técnica </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.surgeryTypeTechnique.name }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col v-if="surgeryIndication.requester">
                      <v-row dense>
                        <v-col class="font-weight-bold"> Requisitado por:</v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.requester.employee.name }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col v-if="surgeryIndication.performer">
                      <v-row dense>
                        <v-col class="font-weight-bold"> Encaminhado para:</v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.performer.employee.name }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col v-if="surgeryIndication.site">
                      <v-row dense>
                        <v-col class="font-weight-bold"> Local </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.site }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col v-if="surgeryIndication.anesthesia">
                      <v-row dense>
                        <v-col class="font-weight-bold"> Anestesia </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ surgeryIndication.anesthesia }}
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col>
                      <v-row dense>
                        <v-col class="font-weight-bold"> Materiais </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col>
                          {{ materials }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <SurgeryIndicationSurgeryDetails
                    :surgery="surgeryIndication.surgery"
                    :attendanceId="attendance.id"
                  />
                </v-col>

                <v-col>
                  <v-row dense>
                    <v-col class="font-weight-bold"> Observação </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ surgeryIndication.observation }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <authorization
                permissionKey="attendance_surgery"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip left v-if="authorization">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      :attrs="attrs"
                      v-on="on"
                      @click="createSurgery"
                      :disabled="disabled"
                    >
                      <v-icon>ri-mental-health-line</v-icon>
                    </v-btn>
                  </template>

                  <span> Realizar Cirurgia </span>
                </v-tooltip>
              </authorization>

              <authorization
                permissionKey="attendance_surgery_indication"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      :attrs="attrs"
                      v-on="on"
                      v-if="authorization && !disabled"
                      :to="`indicacao-cirurgica/${surgeryIndication.id}`"
                    >
                      <v-icon>eva-edit-outline</v-icon>
                    </v-btn>
                  </template>

                  <span> Editar </span>
                </v-tooltip>
              </authorization>

              <authorization
                permissionKey="attendance_surgery_indication"
                can="delete"
                v-slot:default="{ authorization }"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      :attrs="attrs"
                      v-on="on"
                      @click="deleteSurgeryIndication"
                      v-if="authorization && !disabled"
                    >
                      <v-icon>eva-trash-outline</v-icon>
                    </v-btn>
                  </template>

                  <span> Excluir </span>
                </v-tooltip>
              </authorization>
            </v-col>
          </v-row>

          <FileUpload
            ownerType="SurgeryIndication"
            :ownerId="surgeryIndication.id"
          />

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header class="text-h5 gray--text">
                Próteses
              </v-expansion-panel-header>
              <v-expansion-panel-content v-if="surgeryIndication">
                <ProsthesisList
                  :surgeryIndication="surgeryIndication"
                  :surgeryIndicationProstheses="surgeryIndication.prostheses"
                  :allowDelete="!disabled"
                  :allowEdit="!disabled"
                  :showForm="!disabled"
                  @update-surgery-indication-prostheses="updateProstheses"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ProsthesisList from "@/components/surgery_indication/prosthesis/list/index.vue";
import SurgeryIndicationSurgeryDetails from "@/components/surgery_indication/list/surgeryDetails.vue";

export default {
  name: "SurgeryIndicationListItem",
  components: {
    SurgeryIndicationSurgeryDetails,
    ProsthesisList,
  },
  props: {
    attendance: Object,
    surgeryIndication: Object,
    refreshList: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    materials() {
      return this.lodash.join(
        this.surgeryIndication.materials.map((e) => e.name),
        ", "
      );
    },
  },
  methods: {
    updateProstheses(prostheses) {
      this.surgeryIndication.prostheses = prostheses;
    },
    deleteSurgeryIndication() {
      if (confirm("Você realmente deseja deletar essa cirurgia?")) {
        if (this.disabled) return;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery_indication/delete_surgery_indication.gql"),
          variables: {
            surgeryIndicationId: this.surgeryIndication.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Cirurgia deletada com sucesso.",
            type: "success",
          });
        });
      }
    },
    createSurgery() {
      if (this.disabled) return;

      return this.apolloMutate({
        mutation: require("@/graphql/surgery/initialize_surgery.gql"),
        variables: {
          attendanceId: this.attendance.id,
          surgeryIndicationId: this.surgeryIndication.id,
        },
      }).then(({ data }) => {
        this.$router.push(
          `/prontuario/${this.attendance.id}/cirurgia/${data.initializeSurgery.id}`
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
